// extracted by mini-css-extract-plugin
export default {"zone":"Dropzone_zone__hDWUc","dragging":"Dropzone_dragging__xemK7","message":"Dropzone_message__5fVtK","input":"Dropzone_input__RBwek"};